import React from "react";

export const { Provider, Consumer } = React.createContext({ isOpen: false });



// WEBPACK FOOTER //
// ./src/components/Drawer/Context.js